import { ToyBrickIcon } from './ToyBrickIcon';

/**
 * author: Michael Richins
 * id DDCE3E75-1E43-45A9-8D94-E24CFD8284B0
 * name toy-brick
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toy-brick.svg
 * tags
 */
export const LegoIcon = ToyBrickIcon;
export default LegoIcon